export const getLogoByDomainAndAlt = () => {
  const basePath = process.env.PUBLIC_URL || '';

  return {
    logo: `${basePath}/images/logos/gomedulla_light.png`,
    darkLogo: `${basePath}/images/logos/gomedulla_black.png`,
    alt: 'GoMedulla Logo'
  };
};